import { Component, OnInit, Input } from '@angular/core';
import { WebsiteModel, WebsiteTemplateModel } from '../../../../portal.model';

@Component({
  selector: 'app-website-template-item',
  templateUrl: './template-item.component.html',
  styleUrls: ['./template-item.component.css']
})
export class WebsiteTemplateItemComponent implements OnInit {
  @Input() website: WebsiteModel
  @Input() template: WebsiteTemplateModel
  constructor() { }

  ngOnInit() {
  }

}
